import React from 'react';
import styles from './Logo.module.css';

const Logo = ({ size = '1rem' }) => {
  let p1 = process.env.REACT_APP_NAME_P1;
  let p2 = process.env.REACT_APP_NAME_P2;

  return (
    <div className={styles.logoContainer} style={{ fontSize: size }}>
      <span className={styles.p1Text}>{p1}</span>
      {p2 && <span className={styles.p2Text}>{p2}</span>}
    </div>
  );
};

export default Logo;